import { gql } from "@apollo/client";

export const CREATE_POLICY = gql`
  mutation createPolicy($input: createPolicyInput) {
    createPolicy(input: $input) {
      Id
    }
  }
`;



export const GET_POLICY_BY_ORG = gql`
  query policyByOrg($orgId: Int) {
    policyByOrg(orgId: $orgId) {
      description
      policyName
      createdAt
      orgId
      Id
      updatedOn
    }
  }
`;





// Section for Template

export const CREATE_TEMPLATE = gql`
  mutation createTemplate($input: createTemplateInput) {
    createTemplate(input: $input) {
      Id
    }
  }
`;

export const GET_TEMPLATE_BY_ORG = gql`
  query templateByOrg($orgId: Int) {
    templateByOrg(orgId: $orgId) {
      description
      templateName
      title
      titlePosition
      createdAt
      orgId
      Id
      templateUrl
      target
      targetPosition
      signature
      signaturePosition
      signatureImagePosition
      declaration
      declarationPosition
      additionalText
      additionalTextPosition
    }
  }
`;









export const GET_TIMELINE_BY_ORG = gql`
  query timeLineByOrg($orgId: Int) {
    timeLineByOrg(orgId: $orgId) {
      orgId
      noticeperiod
      probationPeriod
    }
  }
`;




